import React, { useEffect } from 'react'
import { Routes as ReactRoutes, Route } from 'react-router-dom'

import BemVindo from '../pages/BemVindo'
import Register from '../pages/Register'
import ConfirmSMS from '../pages/ConfirmSMS'
import SupportingDocuments from '../pages/SupportingDocuments'
import PersonalInfo from '../pages/PersonalInfo'
import Beneficiary from '../pages/Beneficiary'
import ServiceTime from '../pages/ServiceTime'
import Resume from '../pages/Resume'
import End from '../pages/End'
import Erro from '../pages/Erro'
import NotFound from '../pages/NotFound'

import usePersistedState from '../hooks/usePersistedState'
import clientConfig from '../services/clientConfig'
import { ConfigData } from '../utils/interfaces'

const Routes: React.FC = () => {
  const { codCliente, tipo, plano } = clientConfig()

  const [configData, setConfigData] = usePersistedState<ConfigData>(
    'configData',
    {} as ConfigData,
  )

  useEffect(() => {
    setConfigData({
      ...configData,
      codCliente,
      tipo,
      plano,
    })
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <ReactRoutes>
      <Route path="/" element={<BemVindo />} />
      <Route path="/register" element={<Register />} />
      <Route path="/register/confirm-sms" element={<ConfirmSMS />} />
      <Route path="/personal-info" element={<PersonalInfo />} />
      <Route path="/beneficiary" element={<Beneficiary />} />
      <Route path="/service-time" element={<ServiceTime />} />
      <Route path="/supporting-documents" element={<SupportingDocuments />} />
      <Route path="/resume" element={<Resume />} />
      <Route path="/end" element={<End />} />

      <Route path="/erro" element={<Erro />} />
      <Route path="*" element={<NotFound />} />
    </ReactRoutes>
  )
}

export default Routes
